import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Get Entity Type Status',
  make: () => ({
    request: (entityId: string) => ({ http }: any) =>
      http({
        method: 'GET',
        route: `/entity-types/${entityId}/status`,
      }),
  }),
});
